import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class LineApi {
  static uri = "n/internet/Line";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(phone: string) {
    return getData({
      uri: LineApi.uri,
      id: phone,
      context: this.context,
    });
  }
}
